export default {
  common: {},
  virtualsoccer: {
    development: {
      baseURL: 'https://games-vsts.staging.de-3.nsoft.cloud',
      pusherKey: 'c197ae95f575bc466e26',
    },
    staging: {
      baseURL: 'https://games-vsts.staging.de-3.nsoft.cloud',
      pusherKey: 'c197ae95f575bc466e26',
    },
    production: {
      baseURL: 'https://games-vsts.de-3.nsoft.cloud',
      pusherKey: '112cd2f19bc6b016084d',
    },
  },
};
